import { useState, useEffect, useCallback } from 'react';
import api from '../../api';
import { urlEliminazione, messaggioEliminazione, eConflitto, avvisaConflitto } from '../../utils/eliminazione';
import Layout from '../../components/Layout';
import stili from '../../components/competenze/stili';
import FormDicitura from '../../components/competenze/FormDicitura';
import { usePuoScrivere } from '../../utils/permessi';

// Diciture predefinite: testo con variabili, automatica GIS e causale per ciascun fatturante
export default function Diciture() {
  const puoScrivere = usePuoScrivere('competenze');
  const [diciture, setDiciture] = useState([]);
  const [fatturanti, setFatturanti] = useState([]);
  const [cerca, setCerca] = useState('');
  const [inModifica, setInModifica] = useState(null);
  const [errore, setErrore] = useState('');

  const carica = useCallback(() => {
    api.get('/competenze/diciture', { params: { tutte: 1 } }).then(r => setDiciture(r.data))
      .catch(err => setErrore(err.response?.data?.errore || 'Errore nel caricamento'));
  }, []);
  useEffect(() => {
    carica();
    api.get('/competenze/fatturanti').then(r => setFatturanti(r.data)).catch(() => {});
  }, [carica]);

  const elimina = async (d) => {
    if (!window.confirm(`Spostare nel Cestino la dicitura "${d.testo}"? Le prestazioni già registrate non cambiano.`)) return;
    try { await api.delete(urlEliminazione(`/competenze/diciture/${d.id}`, d.version)); carica(); } catch (err) { setErrore(avvisaConflitto(err, messaggioEliminazione(err))); if (eConflitto(err)) carica(); }
  };

  const q = cerca.trim().toLowerCase();
  const filtrate = diciture.filter(d => !q || d.testo.toLowerCase().includes(q) || (d.categoria || '').toLowerCase().includes(q));

  return (
    <Layout>
      <div style={stili.topBar}>
        <h2 style={{ margin: 0 }}>Diciture ({filtrate.length})</h2>
        {puoScrivere && <button onClick={() => setInModifica('nuova')} style={stili.btn}>+ Nuova dicitura</button>}
      </div>
      {errore && <div style={stili.errore}>{errore}</div>}
      <input type="search" placeholder="Cerca dicitura o categoria…" value={cerca} onChange={e => setCerca(e.target.value)} style={{ ...stili.input, marginBottom: '0.8rem' }} />
      <div style={{ overflowX: 'auto' }}>
        <table style={stili.table}>
          <thead>
            <tr>
              <th style={stili.th}>Testo</th>
              <th style={stili.th}>Categoria</th>
              <th style={stili.th}>Voce di listino</th>
              {fatturanti.filter(f => f.attivo).map(f => <th key={f.id} style={stili.th}>{f.nome.split(' ')[0]}</th>)}
              {puoScrivere && <th style={stili.th}>Azioni</th>}
            </tr>
          </thead>
          <tbody>
            {filtrate.map(d => (
              <tr key={d.id} style={{ ...stili.tr, opacity: d.attiva ? 1 : 0.5 }}>
                <td style={stili.td}>
                  {d.testo}
                  {d.automatica_gis && <span style={stili.badgeAuto}>automatica GIS</span>}
                  {Object.keys(d.causali || {}).length === 0 && <span style={{ marginLeft: '0.35rem', fontSize: '0.7rem', color: '#c2410c', background: '#fff7ed', padding: '0.05rem 0.35rem', borderRadius: '4px', whiteSpace: 'nowrap' }}>causale da completare</span>}
                  {!d.attiva && <small style={{ color: '#999' }}> (non attiva)</small>}
                </td>
                <td style={stili.td}>{d.categoria}</td>
                <td style={stili.td}>{d.listino_voce || <span style={{ color: '#999' }}>—</span>}</td>
                {fatturanti.filter(f => f.attivo).map(f => <td key={f.id} style={stili.td}>{d.causali?.[f.id] || <span style={{ color: '#c2410c' }}>—</span>}</td>)}
                {puoScrivere && (
                  <td style={{ ...stili.td, whiteSpace: 'nowrap' }}>
                    <button onClick={() => setInModifica(d)} style={stili.btnSmall}>Modifica</button>
                    <button onClick={() => elimina(d)} style={stili.btnSmallDanger}>Elimina</button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {inModifica && fatturanti.length > 0 && (
        <FormDicitura
          dicitura={inModifica === 'nuova' ? null : inModifica}
          fatturanti={fatturanti}
          onChiudi={() => setInModifica(null)}
          onSalvato={() => { setInModifica(null); carica(); }}
        />
      )}
    </Layout>
  );
}
